import type { RequestInfo } from '@warp-drive/core/types/request';
import { SkipCache } from '@warp-drive/core-types/request';
import { buildQueryRequestUrl } from '../utils/request-url.ts';

const tasAssetUrl = (path: string) => buildQueryRequestUrl('tas-assets', 'tas-assets', path);

/**
 * PATCH a TasAsset's `tags` from an explicit body, rather than from the
 * record's dirty state.
 *
 * `saveExistingRecord` serializes a sparse patch out of the cache, so the
 * mutation IS the payload: the new tags have to be on the record before the
 * request can be built. `tags` drives `uploadRowKey` / `employeeSelectedType`,
 * which the categorized upload rows AND the submission gates
 * (`hasRequiredCategorizedUploads`) read synchronously — so a mutate-then-save
 * makes a document look filed, and count toward its requirement, while the
 * PATCH is still in flight. This builder lets the caller persist first and
 * apply to the record only once the server has accepted it.
 */
export function updateTasAssetTagsRequest(id: string, tags: Record<string, unknown>): RequestInfo {
  return {
    url: tasAssetUrl(id),
    method: 'PATCH',
    body: JSON.stringify({
      data: {
        id,
        type: 'tas-assets',
        attributes: { tags },
      },
    }),
    cacheOptions: {
      [SkipCache]: true,
    },
  };
}
